import React, { useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import queryString from 'query-string';
import { Link } from 'react-router-dom';

import { Button } from '../../utils';
import { SuccessResetPswrd, ResendLink } from '../../HemeIconLibrary';
import { getAllQuestionsForSavePasswordAction, verifyTokenInvitation } from '../../Actions/auth';
import ResendLinkForm from '../../components/resendLink';
import SetAllQuestions from './setQuestons';
import SetPasswordReset from '../setPasswordReset';

const Index = () => {
  const [verifyLink, setVerifyLink] = useState();
  const [allQuestion, setAllQuestion] = useState();
  const [allAnsweredQuestions, setAllAnsweredQuestions] = useState();
  const [token, setToken] = useState();

  useEffect(() => {
    (async () => {
      const querry = queryString.parse(window.location.search);
      const result = await verifyTokenInvitation(querry.token);
      if (result.data) {
        setVerifyLink('pass');
        setToken(querry.token);
      } else {
        setVerifyLink('fail');
      }
      const formulaTest = await getAllQuestionsForSavePasswordAction(querry.token);
      console.log(formulaTest);
      if (formulaTest.status === 200) {
        setAllQuestion(formulaTest.data);
      }
    })();
  }, [window.location.search]);

  return verifyLink === 'pass' ? (
    <SetPasswordReset
      title="Set Password"
      description="You will be using this password for login."
      type="new-password"
      allAnsweredQuestions={allAnsweredQuestions}
      token={token}
      setVerifyLink={setVerifyLink}
    />
  ) : verifyLink === 'fail' ? (
    <div>
      <ResendLinkForm title="Link Expired" Icon={<ResendLink />} description="Looks like the link you used has expired. Please request a new one." />
    </div>
  ) : verifyLink === 'set-questions' ? (
    <div>
      <SetAllQuestions allQuestion={allQuestion} token={token} setVerifyLink={setVerifyLink} setAllAnsweredQuestions={setAllAnsweredQuestions} />
    </div>
  ) : verifyLink === 'set-question-success' ? (
    <div className="max-w-full lg:max-w-[450px]">
      <div className="flex flex-col items-center justify-center w-full">
        <SuccessResetPswrd />
        <h3 className="font-bold pt-[16.44px] pb-[10.38px] text-subheadingColor leading-[48px] text-[40px] font-Inter">Your security questions have been saved successfully.</h3>

        <Link to="/login">
          <Button text="Go to Login" type="submit" bg="bg-primary1" border="border-primary1" color="text-white" className="w-full h-[48px] justify-center font-semibold" />
        </Link>
      </div>
    </div>
  ) : (
    <div className="max-w-full lg:max-w-[450px]">
      <h3 className="font-bold pt-[16.45px] pb-[10.38px] text-subheadingColor leading-[48px] text-[40px] font-Inter">Set Password</h3>
      <Button
        type="submit"
        bg="bg-primary1"
        className="w-full h-[48px] justify-center font-semibold"
        text={
          <>
            <Spinner animation="grow" size="sm" variant="light" />
            <Spinner animation="grow" size="sm" variant="light" />
            <Spinner animation="grow" size="sm" variant="light" />
          </>
        }
      />
    </div>
  );
};

export default Index;
